import type { SVGAttributes } from 'react';
import type { FillColorType, SizePropType, SizeType, StrokeColorType } from './types';

const SIZE_STROKE_WIDTH: Record<SizeType | string, string> = {
  '2xl': '1.5',
  xl: '1.2',
  lg: '1.2',
  md: '1',
} as const;

type Props = {
  color?: StrokeColorType;
  fill?: FillColorType;
  isSizeType: boolean;
  opacity?: SVGAttributes<SVGPathElement>['fillOpacity'];
  path: string;
  size?: SizePropType;
  strokeWidth?: string;
};

const IconPath: React.FC<Props> = (props) => {
  const {
    color = 'black',
    fill = 'none',
    isSizeType,
    opacity = '1',
    path,
    size = '2xl',
    strokeWidth = '1.5',
  } = props;

  return (
    <path
      d={path}
      stroke={color !== 'black' ? `var(--stroke-${color})` : color}
      strokeWidth={isSizeType ? SIZE_STROKE_WIDTH[size] : strokeWidth}
      fill={fill !== 'none' ? `var(--fill-${fill})` : fill}
      fillOpacity={opacity}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  );
};

export default IconPath;

export type IconPathProps = Props;
